type Falsy = false | 0 | '' | null | undefined;

export const isTruthy = <T>(item: T | Falsy): item is T => !!item;

export const isFalsy = <T>(item: T | Falsy): item is Falsy => !item;
